import { jsx } from "react/jsx-runtime";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { validateTidalLicense } from "../../base/index.js";
function LinkOff(props) {
  return /* @__PURE__ */ jsx(
    LinkOffIcon,
    {
      "data-testid": "LinkOff",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LinkOff",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
LinkOff.tidalIconMeta = {
  categories: "editing,attachment",
  name: "LinkOff"
};
validateTidalLicense();
export {
  LinkOff
};
//# sourceMappingURL=LinkOff.js.map
